export default "__VITE_ASSET__72cfc113__"